<template>
  <b-modal v-model="modal" title="Aplicar bloqueio de voos" size="lg" :no-close-on-backdrop="true">
    <loading :active.sync="loading" color="#556ee6" loader="dots" :is-full-page="false"></loading>

    <div v-if="!blocks.length && !loading" class="text-center text-muted py-4">
      <i class="mdi mdi-airplane-off font-size-24"></i>
      <p class="mt-2">Nenhum bloqueio disponível para este participante.</p>
      <small>Crie bloqueios em <strong>Configurações gerais → Bloqueios Aéreos</strong>.</small>
    </div>

    <div v-if="blocks.length">
      <label class="font-weight-bold">Selecione o bloqueio a aplicar:</label>

      <div v-for="block in blocks" :key="block.id" class="block-option" :class="{ 'selected': selectedBlockId === block.id }" @click="selectBlock(block)">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <div class="d-flex align-items-center">
              <input type="radio" :checked="selectedBlockId === block.id" @click.stop="selectBlock(block)" class="mr-2">
              <strong>{{ block.name }}</strong>
              <span v-if="!block.group_id" class="badge bg-info text-light ml-2">Global</span>
            </div>
            <div v-if="block.description" class="text-muted small mt-1">{{ block.description }}</div>
            <div class="mt-2 d-flex flex-wrap">
              <span v-for="(item, idx) in blockItems(block)" :key="idx" class="badge mr-1 mb-1" :class="item.type_flight === 'IDA' ? 'bg-success' : 'bg-warning'">
                {{ item.type_flight }} · {{ item.airline || '—' }} {{ item.flight_number || '' }}
                <span v-if="item.origin && item.destination">({{ item.origin }}→{{ item.destination }})</span>
              </span>
            </div>
          </div>
          <div class="text-right text-muted small">
            <div>{{ (block.items_count || blockItemsLength(block)) }} voo(s)</div>
          </div>
        </div>
      </div>
    </div>

    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close">Cancelar</b-button>
      <b-button variant="primary" @click="apply" :disabled="!selectedBlockId || applying">
        <i class="mdi mdi-airplane-takeoff mr-1"></i>
        {{ applying ? 'Aplicando...' : 'Aplicar bloqueio' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from '@/pages/settings/flight-blocks/services'

export default {
  components: { Loading },
  props: {
    value: { type: Boolean, default: false },
    participantId: { type: [Number, String], default: null },
    participantGroupId: { type: [Number, String], default: null }
  },
  data () {
    return {
      modal: this.value,
      loading: false,
      applying: false,
      blocks: [],
      selectedBlockId: null
    }
  },
  watch: {
    value (val) {
      this.modal = val
      if (val) this.load()
    },
    modal (val) {
      if (!val) this.$emit('input', false)
    }
  },
  methods: {
    async load () {
      this.loading = true
      this.selectedBlockId = null
      try {
        const params = {
          is_active: 1,
          limit: 200
        }
        if (this.participantGroupId) {
          params.available_for_group = this.participantGroupId
        }
        const res = await services.list(params)
        this.blocks = (res.data && res.data.data) ? res.data.data : []
      } catch (err) {
        errorMessage('Erro ao carregar bloqueios.')
        this.blocks = []
      } finally {
        this.loading = false
      }
    },
    blockItems (block) {
      if (!block.items) return []
      return block.items.data ? block.items.data : block.items
    },
    blockItemsLength (block) {
      return this.blockItems(block).length
    },
    selectBlock (block) {
      this.selectedBlockId = block.id
    },
    async apply () {
      if (!this.selectedBlockId || !this.participantId) return
      this.applying = true
      try {
        const res = await services.applyToParticipant(this.selectedBlockId, this.participantId)
        const data = res.data.data || {}
        const msg = res.data.message || `${data.added || 0} voo(s) adicionado(s).`
        successMessage(msg, 3500)
        this.$emit('applied', data)
        this.close()
      } catch (err) {
        const msg = (err.response && err.response.data && err.response.data.message) || 'Erro ao aplicar bloqueio.'
        errorMessage(msg)
      } finally {
        this.applying = false
      }
    },
    close () {
      this.modal = false
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.block-option {
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.block-option:hover {
  border-color: #556ee6;
  background: #f8f9fc;
}
.block-option.selected {
  border-color: #556ee6;
  background: #eef0fb;
  box-shadow: 0 0 0 1px #556ee6;
}
</style>
